import { useEffect } from 'react';
import { Skeleton, Space } from 'antd';

import { ProfileInfoResponse } from 'all-in-one-shared-api';

import ProfileAccountInfo from './components/ProfileAccountInfo';
import ProfileAvatar from './components/ProfileAvatar';
import ProfilePolicyInfo from './components/ProfilePolicyInfo';

import { useProfileInfoContext } from 'contexts/profileInfo';

import { useKeycloakReady } from 'hooks';

export interface ProfileProps {
  data?: ProfileInfoResponse;
}

const ProfilePage = () => {
  const { state: data, isLoading, mutate } = useProfileInfoContext();
  const { token } = useKeycloakReady();

  // Note(Andy Chow): This dirty fix is due to https://generali-hk.atlassian.net/browse/AIOBRB-2156 => make sure the data is revalidated when the users are different
  useEffect(() => {
    if (mutate) mutate();
  }, [token, mutate]);

  return (
    <>
      <Space direction="vertical" style={{ width: '100%' }}>
        {isLoading ? (
          <Skeleton active style={{ marginTop: 24 }} />
        ) : (
          <>
            <ProfileAvatar memberType={data?.memberType ?? ''} />
            <ProfileAccountInfo data={data} />
            <ProfilePolicyInfo data={data} />
          </>
        )}
      </Space>
    </>
  );
};

export default ProfilePage;
